var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "21",
        height: "26",
        viewBox: "0 0 21 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M17.8749 15.4504C19.4904 15.4504 20.8 16.7474 20.8 18.3474V19.5128C20.8 20.921 20.1793 22.259 19.1005 23.1763C17.0653 24.9068 14.1528 25.7526 10.3957 25.7526C6.63925 25.7526 3.7287 24.9071 1.69691 23.177C0.61967 22.2597 0 20.9227 0 19.5157V18.3474C0 16.7474 1.30961 15.4504 2.92509 15.4504H17.8749ZM10.2638 0.0088157L10.3961 0C10.8898 0 11.2977 0.363299 11.3623 0.834654L11.3712 0.965693L11.3701 1.9301L15.9209 1.93075C17.5364 1.93075 18.846 3.22782 18.846 4.82783V10.6279C18.846 12.2279 17.5364 13.525 15.9209 13.525H4.87055C3.25506 13.525 1.94546 12.2279 1.94546 10.6279V4.82783C1.94546 3.22782 3.25506 1.93075 4.87055 1.93075L9.42009 1.9301L9.42111 0.965693C9.42111 0.4768 9.78793 0.0727606 10.2638 0.0088157ZM7.4697 5.79352C6.57272 5.79352 5.84557 6.5137 5.84557 7.40209C5.84557 8.29048 6.57272 9.01067 7.4697 9.01067C8.36668 9.01067 9.09383 8.29048 9.09383 7.40209C9.09383 6.5137 8.36668 5.79352 7.4697 5.79352ZM13.3104 5.79352C12.4135 5.79352 11.6863 6.5137 11.6863 7.40209C11.6863 8.29048 12.4135 9.01067 13.3104 9.01067C14.2074 9.01067 14.9346 8.29048 14.9346 7.40209C14.9346 6.5137 14.2074 5.79352 13.3104 5.79352Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }